function initializeFrozenBelts(){
  document.querySelectorAll('[data-belt]').forEach(root=>{
    if(root.dataset.beltReady)return;
    const images=JSON.parse(root.querySelector('[data-belt-images]').textContent);
    const main=root.querySelector('[data-belt-main]');
    const label=root.querySelector('[data-belt-color-label]');
    const property=root.querySelector('[data-belt-property]');
    let color='red',view='closed';
    const title=s=>s.replace(/(^|-)\w/g,m=>m.replace('-',' ').toUpperCase());
    function render(){
      main.src=images[color][view];
      main.alt=`${title(color)} FROZEN ski belt — ${view==='closed'?'closed magnetic buckle':'open magnetic buckle'}`;
      label.textContent=title(color); property.value=title(color);
      root.querySelectorAll('[data-belt-color]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.beltColor===color)));
      root.querySelectorAll('[data-belt-thumb]').forEach(b=>{const active=b.dataset.beltThumb===view;b.setAttribute('aria-pressed',String(active));b.querySelector('img').src=images[color][b.dataset.beltThumb];});
      root.querySelector('[data-belt-view]').textContent=`${view==='closed'?'Closed':'Open buckle'} · ${view==='closed'?'1':'2'} / 2`;
    }
    root.querySelectorAll('[data-belt-color]').forEach(b=>b.addEventListener('click',()=>{color=b.dataset.beltColor;render();}));
    root.querySelectorAll('[data-belt-thumb]').forEach(b=>b.addEventListener('click',()=>{view=b.dataset.beltThumb;render();}));
    root.querySelector('[data-belt-prev]').addEventListener('click',()=>{view=view==='closed'?'open':'closed';render();});
    root.querySelector('[data-belt-next]').addEventListener('click',()=>{view=view==='closed'?'open':'closed';render();});
    root.dataset.beltReady='true';render();
  });
}
document.addEventListener('DOMContentLoaded',initializeFrozenBelts);
document.addEventListener('shopify:section:load',initializeFrozenBelts);
